import React, { PureComponent } from 'react'
import { func, string } from 'prop-types'
import { Locale } from '@active/react-utils/i18n'
import BillingAddress from '../../common/BillingAddress'
import { postMsg, handleMsg } from './handleIframeMsg'
import connectLocale from '../../../../../shared/utils/connectLocale'

class NewCreditCardForm extends PureComponent {
  static propTypes = {
    getNewCreditCardCallBack: func.isRequired,
    locale: string.isRequired,
    dataSourceUrl: string.isRequired,
  }

  submitBillingAddress = null

  constructor(props) {
    super(props)
    this.state = {
      billingInfo: {},
    }
    this.submitData = this.submitData.bind(this)
  }

  componentDidMount() {
    window.addEventListener('message', this.receiveFrameMsg)
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.receiveFrameMsg)
  }

  getBillingAddressCallBack = values => {
    this.setState({
      billingInfo: values,
    }, () => {
      postMsg(this.iframe, values)
    })
  }

  receiveFrameMsg = e => {
    const { getNewCreditCardCallBack } = this.props
    const { billingInfo } = this.state
    handleMsg(e, this.iframe, getNewCreditCardCallBack, billingInfo)
  }

  submitData = () => {
    this.submitBillingAddress()
  }

  render() {
    const { dataSourceUrl, locale } = this.props
    return (
      <div className="checkout-payments checkout__newCreditCardForm">
        <h2 className="checkout-payments__title">
          <Locale id="passport.lib.components.creditCard.newCreditCardForm.title" />
        </h2>
        <iframe
          title="PCI"
          className="checkout__newCreditCardForm__iframe"
          ref={i => { this.iframe = i }}
          src={`${dataSourceUrl}&locale=${locale}`}
          frameBorder="0"
          scrolling="no"
          width="100%"
        />
        <BillingAddress
          getBillingAddressCallBack={this.getBillingAddressCallBack}
          submitTrigger={submitBillingAddress => {
            this.submitBillingAddress = submitBillingAddress
          }}
        />
      </div>
    )
  }
}

export default connectLocale(NewCreditCardForm)
